function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import React, { useCallback, useContext, useMemo, useRef, useState } from "react";
import cx from "classnames";
import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import { AnimatePresence, motion } from "framer-motion";
import { LinkContext } from "../../../context";
import { twMerge } from "../../../utils";
import { useIsDesktop } from "../../../hooks";
import { Submenu } from "./Submenu";
import { SmallChevronLeft } from "../../icons";
export var NavItem = function(_param) {
    var highlighted = _param.highlighted, className = _param.className, label = _param.label, onClick = _param.onClick, navItems = _param.navItems, children = _param.children, props = _objectWithoutProperties(_param, [
        "highlighted",
        "className",
        "label",
        "onClick",
        "navItems",
        "children"
    ]);
    var isDesktop = useIsDesktop();
    var closeTimeout = useRef(null);
    var ref;
    var isComplex = useMemo(function() {
        return (ref = navItems === null || navItems === void 0 ? void 0 : navItems.some(function(item) {
            var ref;
            return !!((ref = item.navItems) === null || ref === void 0 ? void 0 : ref.length);
        })) !== null && ref !== void 0 ? ref : false;
    }, [
        navItems
    ]);
    var ref1 = _slicedToArray(useState(false), 2), isOpen = ref1[0], setIsOpen = ref1[1];
    var LinkComponent = useContext(LinkContext).LinkComponent;
    var trigger = useMemo(function() {
        if (onClick) {
            return /*#__PURE__*/ React.createElement("button", {
                type: "button",
                className: twMerge("flex items-center justify-start", "text-left text-sm font-medium text-current hover:opacity-60", highlighted && "text-brand-primary-base", className),
                onClick: onClick
            }, /*#__PURE__*/ React.createElement("span", null, children || label), !!isComplex && /*#__PURE__*/ React.createElement(SmallChevronLeft, {
                className: "mt-nudge ml-3 -rotate-90"
            }));
        }
        return /*#__PURE__*/ React.createElement(LinkComponent, _extends({}, props, {
            className: twMerge("transition-all text-sm font-medium text-current hover:text-brand-primary-light", highlighted && "text-brand-primary-base", className)
        }), /*#__PURE__*/ React.createElement("span", {
            className: "flex items-center justify-start"
        }, /*#__PURE__*/ React.createElement("span", null, children || label), !!isComplex && /*#__PURE__*/ React.createElement(SmallChevronLeft, {
            className: "mt-nudge ml-3 -rotate-90"
        })));
    }, [
        props,
        highlighted,
        children,
        label,
        isComplex,
        onClick
    ]);
    var hanlePointerEnter = useCallback(function() {
        if (closeTimeout.current) {
            clearTimeout(closeTimeout.current);
        }
        setIsOpen(true);
    }, []);
    var handlePointerLeave = useCallback(function() {
        closeTimeout.current = setTimeout(function() {
            setIsOpen(false);
        }, 0);
    }, []);
    if (!isDesktop || !(navItems === null || navItems === void 0 ? void 0 : navItems.length) || onClick) {
        return trigger;
    }
    return /*#__PURE__*/ React.createElement(DropdownMenu.Root, {
        modal: false,
        open: isOpen
    }, /*#__PURE__*/ React.createElement(DropdownMenu.Trigger, {
        className: "block",
        onPointerEnter: hanlePointerEnter,
        onPointerLeave: handlePointerLeave
    }, trigger), /*#__PURE__*/ React.createElement(DropdownMenu.Portal, {
        forceMount: true
    }, /*#__PURE__*/ React.createElement(DropdownMenu.Content, {
        className: "z-20",
        onPointerEnter: hanlePointerEnter,
        onPointerLeave: handlePointerLeave
    }, /*#__PURE__*/ React.createElement(AnimatePresence, null, !!isOpen && /*#__PURE__*/ React.createElement(motion.div, {
        key: "content",
        initial: {
            opacity: 0
        },
        exit: {
            opacity: 0
        },
        animate: {
            opacity: 1
        },
        transition: {
            duration: 0.2
        },
        className: cx("p-7", isComplex && "w-screen")
    }, /*#__PURE__*/ React.createElement("div", {
        className: "container"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "p-8 rounded-lg bg-bg-default shadow-xl shadow-bg-inverted/10"
    }, /*#__PURE__*/ React.createElement(Submenu, {
        variant: isComplex ? "complex" : "simple",
        navItems: navItems
    }))))))));
};

//# sourceMappingURL=NavItem.js.map